import type { StoreCurrentResponse } from "@toema/shared-types";

/**
 * Shop identity shown in the header, the footer and on the ticket.
 *
 * This used to be a hardcoded constant, with a comment explaining that the
 * backend had nowhere to keep it. It does now: `store_profile`, edited from
 * the dashboard and served by `GET /stores/current`. A store's own name,
 * address and phone are the store's to change, and changing them must not
 * require a rebuild by someone with the repository checked out.
 */
export interface ShopIdentity {
  readonly name: string;
  readonly tagline: string | null;
  /** One line per line as printed; the footer does not re-wrap them. */
  readonly addressLines: readonly string[];
  /** As a human dials it. */
  readonly phone: string | null;
  /** The same number in E.164, for the `tel:` href. */
  readonly phoneHref: string | null;
}

export function shopFrom(store: StoreCurrentResponse): ShopIdentity {
  return {
    name: store.name,
    tagline: store.profile.tagline,
    addressLines: store.profile.addressLines,
    phone: store.profile.phone,
    phoneHref: store.profile.phoneE164,
  };
}
